// T-6 跨页面共享任务 / 结果状态（前端内存态，后端无 list 接口）
import Vue from 'vue';

// 隐私保护：上传文件与转换结果的保留时长（小时）。
// 后端 config.yaml 的 storage.retention_hours 必须与此一致（当前 168 小时 = 7 天，
// 后端默认值见 ceanx-office-py/ceanx/config.py；曾短暂为 2 小时，2026-10-18 已统一为 7 天）。
export const RETENTION_HOURS = 168;

export const taskStore = Vue.observable({
  tasks: [] // { id, fileName, source, target, status, progress, result, error, hint, createdAt, retentionHours }
});

export function addTask(task) {
  taskStore.tasks.unshift(task);
}

export function updateTask(id, patch) {
  const t = taskStore.tasks.find((x) => x.id === id);
  if (t) Object.assign(t, patch);
  return t;
}

export function removeTask(id) {
  const i = taskStore.tasks.findIndex((x) => x.id === id);
  if (i >= 0) taskStore.tasks.splice(i, 1);
}

export function clearFinished() {
  taskStore.tasks = taskStore.tasks.filter((t) => t.status !== 'success' && t.status !== 'failed');
}

/**
 * 「文档转换 → OCR 识别」一次性文件交接（内存态，不写 URL）。
 *
 * 场景：转换页上传扫描件后提示改用 OCR，用户同意 → 跳到 OCR 页。
 * 此时文件**已经**由 el-upload 传到 /api/files/upload/multiple（entry.name 就是
 * 存储名），OCR 页直接用 fileId 提交，不再让用户重选、也不再重复上传一遍。
 *
 * 只放一份、取完即清：用户手动刷新 OCR 页后交接自然失效（本地已无该状态），
 * 不会出现"打开 OCR 页就莫名带着上次的文件"。
 */
export const ocrHandoff = Vue.observable({ file: null });

export function setOcrHandoff(file) {
  ocrHandoff.file = file || null;
}

export function takeOcrHandoff() {
  const f = ocrHandoff.file;
  ocrHandoff.file = null;
  return f;
}
